const CHARCODE_A = 'A'.charCodeAt(0);
const CHARCODE_0 = '0'.charCodeAt(0);

function mod97(value: string) {
  let buffer = 0;
  let charCode;

  for (let i = 0; i < value.length; ++i) {
    charCode = value.charCodeAt(i);

    buffer = charCode + (charCode >= CHARCODE_A ? buffer * 100 - CHARCODE_A + 10 : buffer * 10 - CHARCODE_0);

    if (buffer > 1000000) {
      buffer %= 97;
    }
  }

  return buffer % 97;
}

export const ISO7064computeWithoutCheck = (rawValue: string) => {
  return mod97(rawValue);
};
